export default "__VITE_ASSET__RFIR8m9D__"